<template>
  <div>
    <div class="relative" @click="localValue = true">
      <div class="overflow-hidden" :style="{ maxHeight: (localValue ? 9999 : maxHeight) + 'px' }" style="overflow-wrap: anywhere;">
        <div ref="$content">
          <slot :model-value="localValue || !isClamped" />
        </div>
      </div>

      <div
        class="h-2/3 min-h-[50px] bg-gradient-to-t transition text-center absolute left-0 bottom-0 w-full pointer-events-none"
        :class="[ localValue ? 'opacity-0' : '', theme?.base ? '' : gradientColor ]"
        :style="theme?.base ? {
          '--tw-gradient-from': theme.base.background[ isWeak ? 'weak' : 'base'],
          '--tw-gradient-to': theme.base.background[ isWeak ? 'weak' : 'base'] + '00',
          '--tw-gradient-stops': 'var(--tw-gradient-from), var(--tw-gradient-to)'
        } : {}"
        v-if="isClamped && !isInline"
      />

      <div class="h-6 w-56 absolute bottom-0 right-0 pointer-events-none bg-gradient-to-l" :class="[ theme?.base ? '' : gradientColor ]" :style="theme?.base ? {
        '--tw-gradient-from': theme.base.background[ isWeak ? 'weak' : 'base'],
        '--tw-gradient-to': theme.base.background[ isWeak ? 'weak' : 'base'] + '00',
        '--tw-gradient-stops': 'var(--tw-gradient-from), var(--tw-gradient-to)'
      } : {}" v-if="isClamped && !localValue && isInline" />
    </div>

    <div
      class="text-left"
      :class="[
        localValue ? 'mt-6' : 'mt-3',
        isInline ? 'flex items-center justify-between rounded-md px-2.5 py-1.5 bg-light-200 dark:bg-dark-700 cursor-pointer text-2xs font-medium' : ''
      ]"
      @click.prevent.stop="localValue = !localValue"
      v-if="isClamped"
    >
      <p>{{ localValue ? $t('actions.showLess') : $t('actions.showMore') }}</p>

      <IconBase name="cute/angle-right" :width="16" :class="[ localValue ? '-rotate-90' : 'rotate-90']" v-if="isInline" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Theme } from '@/classes'

const props = withDefaults(defineProps<{
  modelValue?: boolean
  maxHeight?: number
  isWeak?: boolean
  isInline?: boolean
  gradientColor?: string
  color?: '' | 'white' | 'slate'
  theme?: Theme | null
}>(), {
  modelValue: false,
  maxHeight: 200,
  isWeak: false,
  isInline: false,
  theme: null,
  color: '',
  gradientColor: 'from-royal-50 to-royal-50/0'
})

const emit = defineEmits<{
  (e: 'update:modelValue', v: boolean): void
}>()

useKeepAlive({
  onStart: () => {
    onRefresh()
  }
})

const $content = ref()
const { height: contentHeight } = useElementSize($content)

const localValue = ref(false)
const isClamped = ref(false)

const onRefresh = () => {
  setTimeout(() => isClamped.value = contentHeight.value > props.maxHeight, 100)
}

watch(localValue, () => {
  emit('update:modelValue', localValue.value)
})
</script>